export default {
  projectsPage: {
    kicker: "Community",
    title: "Projects",
    subtitle:
      "Create research and creative projects, get community ratings and support from RSL experts.",
    propose: "Propose a project",
    createTitle: "New project",
    editTitle: "Edit project",
    open: "Open",
    edit: "Edit",
    delete: "Delete",
    submit: "Submit for moderation",
    complete: "Complete",
    save: "Save",
    saving: "Saving...",
    loadMore: "Load more",
    goToPortal: "Go to Projects Portal",
    authRequired: "You need to sign in to manage a project",
    requiredFields: "Fill required fields",
    relevanceMinLength: "Relevance must contain at least 10 characters",
    neededResourcesRequired: "Select at least one needed resource",
    participationGoalRequired: "Select at least one participation goal",
    classifiersRequired: "Select thinking type, maturity stage, direction, and legal status",
    consentsRequired: "All consents must be checked before submitting a project",
    coverImageUrlRequired: "Upload a cover image",
    presentationFileUrlsRequired: "Upload at least one presentation file",
    loadError: "Could not load projects. Please try later.",
    loadMoreError: "Could not load more projects.",
    saveError: "Could not save project",
    submitModerationServerRejected:
      "The server rejected submission for moderation. Your project was saved as a draft — try again from My Projects later, or contact support if this keeps happening.",
    deleteError: "Could not delete project",
    workflowError: "Could not execute project action",
    detailLoadError: "Could not load project",
    statusAll: "All statuses",
    sortNewest: "Newest first",
    sortOldest: "Oldest first",
    sortTitleAsc: "By title (A→Z)",
    sortTitleDesc: "By title (Z→A)",
    empty: "No projects found",
    emptyTitle: "No projects found",
    emptyDescription: "Try changing filters or go to the portal to create a new project.",
    activeFilters: "Active filters:",
    resetFilters: "Reset",
    resetFiltersAria: "Clear search, status filter, and sorting to defaults",
    searchFilter: "Search: \"{{query}}\"",
    filterGroups: {
      all: "All statuses",
      drafts: "Drafts",
      review: "In review",
      evaluation: "Evaluation",
      team: "Team",
      completed: "Completed",
      rejected: "Rejected",
    },
    export: {
      title: "Export to Excel",
      toolbarButton: "Export to Excel",
      toolbarAria: "Open project export to Excel settings",
      close: "Close",
      cancel: "Cancel",
      download: "Download",
      loadingCatalog: "Loading export fields…",
      catalogLoadError: "Could not load field list. Please try again.",
      downloadError: "Could not download the file. Please try again.",
      noProjectFieldsSelected: "Select at least one project field.",
      sheetsTitle: "Sheets",
      sheetProjects: "Projects",
      sheetTeam: "Team",
      projectFieldsTitle: "Project fields",
      teamFieldsTitle: "Team fields",
      selectAll: "Select all",
      clearAll: "Clear all",
      ungrouped: "Other",
      multiStatusFilterHint:
        "Status group filter is not sent to the server. All projects matching the search query will be exported.",
      tooManyRows: "Too many projects to export (maximum 5000). Narrow your filters.",
    },
    projectCount_one: "{{count}} project",
    projectCount_other: "{{count}} projects",
    notFound: "Project not found",
    back: "Back",
    backToList: "Back to projects",
    searchLabel: "Search projects",
    searchPlaceholder: "Search by title or description\u2026",
    confirmDeleteTitle: "Delete project?",
    confirmDelete: "Delete project?",
    rejectionReason: "Rejection reason",
    fields: {
      title: "Title",
      shortDescription: "Short description",
      mainProblem: "Main problem",
      relevance: "Relevance",
      maturityStage: "Maturity stage",
      legalStatus: "Legal status",
      direction: "Direction",
      thinkingType: "Thinking type",
      participationGoal: "Participation goal",
      neededResources: "Needed resources",
      currentRealizationStatus: "Current realization status",
      existingPartners: "Existing partners",
      mediaMentions: "Media mentions",
      expertRecommendations: "Expert recommendations",
      coverImage: "Cover image",
      presentationFiles: "Presentation files",
      finalScoreInitial: "Final score (initial round)",
      finalScoreAdditional: "Final score (additional round)",
      teamMembers: "Team",
      status: "Status",
      creationTime: "Created",
    },
    stages: {
      moderation: "Moderation",
      evaluation: "Evaluation",
      team: "Team",
    },
    detailSections: {
      about: "About",
      realization: "Realization",
      resources: "Resources and partners",
    },
    form: {
      title: "Project title",
      titleHint: "Max 60 characters",
      shortDescription: "Short description",
      shortDescriptionHint: "Max 200 characters",
      mainProblem: "Main problem",
      mainProblemHint: "Max 512 characters",
      relevance: "Relevance",
      relevanceHint: "10 to 1000 characters",
      currentRealizationStatus: "Current realization status",
      currentRealizationStatusHint: "Max 2000 characters",
      existingPartners: "Existing partners",
      existingPartnersHint: "Max 1000 characters",
      mediaMentions: "Media mentions",
      mediaMentionsHint: "Max 1000 characters",
      expertRecommendations: "Expert recommendations",
      expertRecommendationsHint: "Max 1000 characters",
      coverImageUrl: "Cover image",
      coverImageUploadHint: "Allowed formats: JPG, PNG, JFIF. Maximum size 10 MB.",
      coverImageInvalidFormat: "Please choose a JPG, PNG, or JFIF file.",
      presentationFileUrls: "Presentation files (up to 2)",
      presentationFileCount: "Attached files: {{current}} of {{max}}",
      presentationAddAnother: "Add another file",
      presentationUploadHint:
        "Up to two files: PDF or images (JPG, PNG, JFIF) only. At least one file is required. Maximum {{maxMb}} MB per file. Save PowerPoint decks as PDF.",
      presentationInvalidFormat: "Only PDF, JPG, PNG, and JFIF files are allowed.",
      presentationFileTooLarge: "This file is larger than {{maxMb}} MB. Please choose a smaller file.",
      selectPlaceholder: "Select…",
      thinkingType: "Thinking type",
      participationGoal: "Participation goal",
      maturityStage: "Maturity stage",
      direction: "Project direction",
      legalStatus: "Legal status",
      neededResources: "Needed resources",
      consentPersonalData: "Consent to personal data processing",
      consentIpRights: "Consent to IP rights transfer",
      consentDocumentsReadiness: "Confirm document readiness",
      consentPhotoVideo: "Consent to photo/video",
      consentDocumentLink: "Open document",
      submitNow: "Submit for moderation immediately",
      saveDraft: "Save draft",
      submitForModeration: "Submit for moderation",
      nextStep: "Next",
      prevStep: "Back",
      progress: "{{completed}} of {{total}} required items completed",
      steps: {
        idea: "Idea",
        status: "Status",
        resources: "Resources",
        submit: "Submit",
      },
    },
    portal: {
      pageTitle: "Projects Portal",
      pageSubtitle: "Accelerator project management",
      sidebarAria: "Projects portal navigation",
      navAria: "Portal sections",
      navWorkGroups: {
        moderation: "Moderation & scoreboard",
        evaluation: "Expert evaluation",
        criteria: "Evaluation criteria",
        team: "Project teams",
      },
      mySubtitle: "Your applications and projects you joined as a team member after accepting an invitation.",
      registrySubtitle: "Project catalogue with filters and cards inside the portal.",
      nav: {
        newApplication: "New project",
      },
      my: {
        emptyCta: "Create a new project",
        ownedSectionTitle: "My applications",
        ownedSectionHint: "Drafts, returned applications, and projects you created and submitted.",
        ownedSectionEmpty: "You have no project applications yet.",
        teamSectionTitle: "Projects I joined",
        teamSectionHint: "Projects you were invited to and accepted.",
        teamSectionEmpty: "No team projects yet.",
        teamMemberBadge: "Team member",
        teamRoleLabel: "Role: {{role}}",
        goToMyProjects: "Go to My Projects",
      },
      tabs: {
        overview: "Overview",
        myProjects: "My Projects",
        registry: "Project Registry",
        moderation: "Moderation",
        evaluation: "Evaluation",
        criteria: "Criteria",
        scoreboard: "Scoreboard",
        evaluationSummaryByExperts: "Scores by experts",
        evaluationSummaryByProjects: "Scores by projects",
        teamInvitations: "Invitations",
        team: "Teams",
      },
      overview: {
        title: "Projects Overview",
        subtitle: "Quick access to your projects and role-based work queues.",
        retry: "Retry",
        statsLoading: "Loading project statistics",
        statsLoadError: "Could not load project summary",
        goToSection: "Go to section",
        myHint: "Track your drafts, returned applications, and submitted projects.",
        myDraftsAndReturns_one: "{{count}} draft or revision",
        myDraftsAndReturns_other: "{{count}} drafts or revisions",
        moderationHint: "Projects awaiting moderation review.",
        evaluationHint: "Projects ready for initial or additional expert evaluation.",
        teamHint: "Projects in moderation, evaluation, or team formation available for team management.",
      },
      intro: {
        title: "Apply with Project",
        subtitle: "Fill in the project card, save a draft, or submit the application for moderation.",
        hint: "The constructor opens in My Projects so drafts and submitted applications stay together.",
        howTitle: "How application works",
        step1Title: "Describe the idea",
        step1Desc: "Add the title, problem, relevance, and short project description.",
        step2Title: "Clarify the status",
        step2Desc: "Choose direction, maturity, legal status, and participation goal.",
        step3Title: "Submit the application",
        step3Desc: "Specify needed resources, add links, and confirm consents.",
        startCta: "Start filling",
        backToList: "Back to my projects",
      },
      metrics: {
        drafts: "My drafts",
        moderation: "In moderation",
        evaluation: "Awaiting evaluation",
        team: "Team formation",
      },
    },
    moderation: {
      stageModeration: "Moderation",
      stageEvaluation: "Evaluation",
      stageTeam: "Team",
      approveModeration: "Approve and send to evaluation",
      returnForRevision: "Return for revision",
      rejectAtModeration: "Reject",
      requestAdditionalEvaluation: "Request additional evaluation",
      passEvaluation: "Pass evaluation",
      rejectAtEvaluation: "Reject at evaluation",
      startTeamFormation: "Start team formation",
      complete: "Complete project",
      finalizeRound: "Finalize round",
      criteriaWeightsInvalid:
        "Cannot finalize the round: active criteria weights must sum to 100. Current sum: {{sum}}.",
      reasonPlaceholder: "Reason (optional)\u2026",
      confirmAction: "Confirm action?",
      noProjects: "No projects for this stage",
      createdToday: "created today",
      createdDaysAgo_one: "created {{count}} day ago",
      createdDaysAgo_other: "created {{count}} days ago",
      openProject: "Open project",
      actionsTitle: "Actions",
      scoreLine: "Score: {{value}}/100",
      scorePrefix: "Score:",
      scoreValue: "{{value}}/100",
      evaluationProgress: "Evaluation progress",
      roundLabelInitial: "Round 1",
      roundLabelAdditional: "Round 2",
      hints: {
        approveModeration: "the project moves straight to expert evaluation.",
        returnForRevision: "the author will see the reason and can edit the application.",
        finalizeRound: "the system checks criteria weights and finalizes the round score.",
        requestAdditionalEvaluation: "the project moves to an additional evaluation round.",
        passEvaluation: "the project will be marked as successfully evaluated.",
        startTeamFormation: "team composition can be managed after this.",
        complete: "the project will move to completed.",
        reject: "the project moves to a rejected status with the specified reason.",
        rejectAtEvaluation: "the project moves to a rejected status with the specified reason",
      },
    },
    evaluation: {
      title: "Expert Evaluation",
      selectProject: "Select a project",
      viewProject: "View project",
      viewProjectTooltip: "Open the project page in the portal: summary, status, and materials",
      round: "Round",
      roundInitial: "Initial",
      roundAdditional: "Additional",
      additionalRoundBlocked:
        "Additional evaluation is only available for projects you fully evaluated in the initial round.",
      queue: {
        additionalRoundRequiresInitial:
          "The additional round queue only shows projects you fully evaluated in the initial round.",
        filterLabel: "Filter",
        filterAll: "All",
        filterEvaluated: "Evaluated",
        filterNotEvaluated: "Not evaluated",
        evaluated: "Evaluated",
        expertScore: "Score",
        goToEvaluation: "Go to evaluation",
        criteriaHint: "Active criteria: {{count}}",
        projectsEvaluatedCount: "Evaluated {{evaluated}} of {{total}} projects",
        allProjectsEvaluated: "All projects are evaluated",
        sortAria: "Sort: {{column}}, {{direction}}",
        sortDirectionAsc: "ascending",
        sortDirectionDesc: "descending",
        sortDirectionNone: "unsorted",
      },
      criteriaTitle: "Criterion",
      score: "Score",
      comment: "Comment",
      submitScores: "Submit scores",
      submitting: "Submitting\u2026",
      submitSuccess: "Scores submitted",
      submitError: "Could not submit scores",
      aggregateScore: "Aggregate score",
      aggregateScoreExpert: "Your total by criteria",
      commissionRoundFinalLabel: "Official round score (commission)",
      finalized: "Round finalized",
      notFinalized: "Round not finalized",
      yesNoYes: "Yes",
      yesNoNo: "No",
      scoresLoadError: "Could not load scores",
      projectsLoadError: "Could not load projects for evaluation",
      noCriteria: "There are no active criteria for the selected round",
      scoreProgress: "Criteria completed: {{completed}} of {{total}}",
      expertCount: "Experts evaluated: {{count}}",
      criteriaAveragesTitle: "Criteria averages",
      criteriaAveragesTitleExpert: "Your criteria summary",
      criteriaAveragesEmpty: "No expert data yet",
      criteriaAveragesEmptyExpert: "No summary data yet",
      criteriaTableCriterion: "Criterion",
      criteriaTableWeight: "Weight",
      criteriaTableScorePoints: "Score (0–100)",
      breakdownTitle: "Experts breakdown",
      breakdownLoadError: "Could not load experts breakdown",
      breakdownEmpty: "No scores yet",
      breakdownExpert: "Expert",
      breakdownTotalScore: "Total score",
      breakdownColScore: "Score (0–100)",
      breakdownColWeight: "Weight",
      breakdownColComment: "Comment",
      breakdownExpand: "Expand",
      breakdownCollapse: "Collapse",
    },
    criteria: {
      title: "Evaluation Criteria",
      create: "Add criterion",
      editTitle: "Edit criterion",
      createFormTitle: "New criterion",
      name: "Title",
      description: "Description",
      type: "Type",
      typeYesNo: "Yes/No",
      typeNumericScale: "Numeric scale",
      scaleValues: "Scale values",
      addScaleValue: "Add value",
      removeScaleValue: "Remove",
      scaleDescriptionPlaceholder: "Value description",
      scaleValuesEmptyHint: "Add at least one scale value",
      scaleValuesEmpty: "Add at least one scale value",
      scaleValuesMinCount: "Add at least two scale values",
      scaleValueMustBeInteger: "Scale value must be an integer",
      scaleValueDuplicate: "Scale values must be unique",
      scaleDescriptionRequired: "Fill in description for value {{value}}",
      scaleValuesCount: "Values: {{count}}",
      minValue: "Min",
      maxValue: "Max",
      weight: "Weight",
      round: "Round",
      active: "Active",
      sortOrder: "Sort order",
      save: "Save",
      delete: "Delete",
      confirmDeleteTitle: "Delete criterion?",
      confirmDelete: "Delete criterion?",
      weightsValid: "Weights sum = 100",
      weightsInvalid: "Weights sum \u2260 100",
      currentSum: "Current sum",
      weightRemaining: "Weight available: {{remaining}}",
      weightExceededRemaining: "Weight exceeds remaining capacity. You can set up to {{remaining}}",
      createDisabledRoundFull: "Cannot add criterion: weights sum for round \"{{round}}\" is already 100",
      createDisabledAllRoundsFull: "Cannot add criterion: weights sum in both rounds is already 100",
      empty: "No criteria have been created yet",
      inactive: "inactive",
      loadError: "Could not load criteria",
      saveError: "Could not save criterion",
      deleteError: "Could not delete criterion",
    },
    scoreboard: {
      title: "Scoreboard",
      rank: "№",
      projectTitle: "Project",
      status: "Status",
      finalScore: "Final score",
      round: "Round",
      empty: "No data to display",
      loadError: "Could not load scoreboard",
      moderatorHint:
        "Only projects with a finalized aggregate score for the selected round are listed. Projects still being evaluated or without a finalized round do not appear here.",
      expertSubsetHint:
        "This is the ranking of projects you scored in the selected round. The \"Final score\" column shows each project's aggregate score once the round is finalized. Expand a row to see your per-criterion scores and comments.",
      prevPage: "Previous page",
      nextPage: "Next page",
    },
    evaluationSummary: {
      byExpertsTitle: "Evaluation summary by experts",
      byExpertsSubtitle: "Per expert: projects and criterion scores for the selected round.",
      byProjectsTitle: "Evaluation summary by projects",
      byProjectsSubtitle: "Per project: experts and criterion scores for the selected round.",
      filterProjectSearchPlaceholder: "Search by project title",
      filterProjectSearchAria: "Search evaluation summary by project title",
      filterExpertSearchPlaceholder: "Search by expert name",
      filterExpertSearchAria: "Search evaluation summary by expert name",
      loadError: "Could not load summary",
      empty: "Nothing to display",
      projectsUnderExpert: "Projects",
      expertsUnderProject: "Experts",
      projectTotalScore: "Score for project",
    },
    team: {
      title: "Team Management",
      subtitle:
        "Projects in moderation, evaluation, and team formation. Select a project to manage its team.",
      selectProjectHint: "Select a project from the list to view and edit its team.",
      noTeamProjects: "No projects at this stage",
      noTeamProjectsCta: "Go to moderation",
      projectListAria: "Projects available for team management",
      projectSearchPlaceholder: "Search by title or description…",
      memberSearch: "Member",
      addMemberTitle: "Add team member",
      editMemberTitle: "Edit team member",
      addMemberStatusHint: "The member will be added with status «Invited».",
      openProject: "Open project card",
      roleEmpty: "—",
      authorRole: "Author",
      actionsColumn: "Actions",
      membersListAria: "Project team members",
      summaryAria: "Team status summary",
      summaryInvited: "Invited: {{count}}",
      summaryAccepted: "Accepted: {{count}}",
      summaryDeclined: "Declined: {{count}}",
      summaryTotal: "Total: {{count}}",
      invitationsSectionTitle: "Team invitations",
      invitationsSectionLead:
        "Invitations appear when a project owner adds you as a team member. You can accept or decline while the invitation remains active.",
      invitationsEmpty: "You have no pending team invitations.",
      invitationsLoadError: "Could not load invitations.",
      invitationActionError: "Could not complete the action. The invitation may no longer be valid.",
      invitationUntitledProject: "Untitled project",
      acceptInvitation: "Accept",
      declineInvitation: "Decline",
      acceptInvitationAria: "Accept team invitation for project «{{title}}»",
      declineInvitationAria: "Decline team invitation for project «{{title}}»",
      invitationsListAria: "List of project team invitations",
      invitationProjectHint: "If you accept, you will join this project’s team.",
      invitationAcceptedHint: "Invitation accepted. The project will appear under My Projects → Projects I joined.",
      viewProject: "View project",
      viewProjectAria: "View project card for «{{title}}»",
      viewProjectTooltip: "Open project description, status, and materials",
      selectProject: "Select a project",
      addMember: "Add member",
      userId: "User ID",
      userLookupPlaceholder: "Start typing full name, username, or email",
      userLookupMinChars: "Type at least 2 characters to search",
      userLookupNoResults: "No users found",
      role: "Role",
      rolePlaceholder: "Team role",
      status: "Status",
      statusInvited: "Invited",
      statusAccepted: "Accepted",
      statusDeclined: "Declined",
      save: "Save",
      remove: "Remove",
      editMemberAria: "Edit team member: {{name}}",
      removeMemberAria: "Remove team member {{name}}",
      confirmRemoveTitle: "Remove member?",
      confirmRemove: "Remove team member?",
      noMembers: "No team members yet",
      projectsLoadError: "Could not load projects for team formation",
      loadError: "Could not load team",
      saveError: "Could not save",
      removeError: "Could not remove member",
    },
  },
}
